import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateOrUpdateFormPartnerOfferings(
    $formId: Int!
    $partnerOfferings: [PartnerOfferingInput]
  ) {
    createOrUpdateFormPartnerOfferings(
        formId: $formId
        partnerOfferings: $partnerOfferings
    ) {
        formId
        enabled
        partnerOfferingId
        updatedBy
    }
  }
`;
